import { Box, Grid } from '@mui/material';
import { SxProps, Theme, styled } from '@mui/material/styles';
import React from 'react';
import { useIntl } from 'react-intl';
import ClearSelection from './clear-selection';

type FilterSidebarProps = {
  marginTop?: number | string;
  clearFiltersPlacement?: 'flex-start' | 'flex-end';
  children: React.ReactNode;
  clearFilters?: () => void;
  sx?: SxProps<Theme> | undefined;
  showClearFilter?: boolean;
  dark?: boolean;
};

const StyledGrid = styled(Grid, {
  label: 'FilterSideBar-root',
  shouldForwardProp: (props) => props !== 'dark',
})(({ theme }) => ({
  width: '100%',
  gap: 16,
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flexWrap: 'wrap',
    align: 'flex-start',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

const FilterSidebar: React.FC<FilterSidebarProps> = ({
  showClearFilter = false,
  clearFiltersPlacement = 'flex-end',
  marginTop = 0,
  children,
  clearFilters,
  dark = false,
  sx,
  ...props
}) => {
  const intl = useIntl();

  return (
    <Box display={'flex'} flexDirection={'column'} gap={2}>
      <StyledGrid sx={sx} className="FilterSideBar" marginTop={marginTop} {...props}>
        {children}
      </StyledGrid>
      {showClearFilter && (
        <ClearSelection
          dark={dark}
          text={intl.formatMessage({ id: `general.clearFilterLabel` })}
          onClick={clearFilters}
          sx={{ justifyContent: clearFiltersPlacement }}
        />
      )}
    </Box>
  );
};

export default FilterSidebar;
